import React, {useEffect, useState} from "react";
import DataGrid from "../../General/DataGrid/DataGrid";
import service from "../../../service/service";


const columns = [
    {
        field: "Account_AccountId",
        headerName: 'Account Id',
        resizable: true,
        sortable: true,
        suppressAutoSize: true,
        
    },
    {
        field: "AccountAlias",
        headerName: 'Account Alias',
        resizable: true,
        sortable: true,
        suppressAutoSize: true,
    },
    {
        field: "ApplicationName",
        headerName: 'ApplicationName',
        resizable: true,
        sortable: true,
        suppressAutoSize: true,
    },
   
    {
        field: "Region_RegionCode",
        headerName: 'Region',
        resizable: true,
        sortable: true,
        suppressAutoSize: true,
    },
    {
        field: "ImageId",
        headerName: 'Image Id',
        resizable: true,
        sortable: true,
        suppressAutoSize: true,
    },
    {
        field: "ImageName",
        headerName: 'Image Name',
        resizable: true,
        sortable: true,
        suppressAutoSize: true,
    },
    {
        field: "InstanceId",
        headerName: 'Instance Id',
        resizable: true,
        sortable: true,
        suppressAutoSize: true,
    },
    {
        field: "CreationDate",
        headerName: 'Creation Date',
        resizable: true,
        sortable: true,
        suppressAutoSize: true,
    }
]
export default function UnUsedAmiAccountSummary({accountId, filter, expanded ,id}) {
    const [loading, setLoading] = useState(false);
    const [ready, setReady] = useState(false);
    const [accountWiseData, setAccountWiseData] = useState([]);
    
    const [error, setError] = useState({
        error: false,
        errorMessage: undefined
    })
   
    useEffect(() => {
        // trigger on account id change
        if(expanded === id){
        let param = filter
        if (!param.region){
            param = {
                region: '',
                key: '',
                value: ''
            }
        }
    
        setLoading(true)
        setReady(false);
        setError({
            error: false,
            errorMessage: undefined
        })
        // run the api call for loading account wise recommendation
        setAccountWiseData([])
        service.monitoring().getListUnusedAMI({account_id: accountId, filter: param})
            .then((res) => {
                //console.log(res)
                setAccountWiseData(res.data.instance) 
                setReady(true);
                setLoading(false);
            })
            .catch((err) => {
                setError({
                    error: true,
                    errorMessage: err.message
                })
            })
        }
    }, [expanded])
   
    

 

    return (
        <div style={{width:'100%'}}>
             {
                !loading ? 
                ready &&
                <DataGrid
                    fixedColumn={columns}
                    fileName={`AMI`}
                    gridStyle={{height: "400px"}}
                    gridData={(accountWiseData.length > 0) ? accountWiseData:[]}/>
                : "loading..."
            }
            {
                error.error &&
                `something went wrong. Error message: ${error.errorMessage}`
            }
        </div>
    )
}